import { extractStringValueSet } from './extract-properties';

/**
 * Lists the supported types of order items
 */
export default class SupportedItemType {

    static readonly AbstractPatient: string = 'abstract-patient';
    static readonly AccessionSample: string = 'accession-sample';
    static readonly AnalyzeChip: string = 'analyze-chip';
    static readonly AnalyzeDrdJanssen: string = 'analyze-drd-janssen';
    static readonly AnalyzeDiplotypeCall: string = 'analyze-diplotype-call';
    static readonly AnalyzeEcgAf: string = 'analyze-ecg-af';
    static readonly AnalyzeEcgRechommend: string = 'analyze-ecg-rechommend';
    static readonly AnalyzeDPYD: string = 'analyze-dpyd';
    // eslint-disable-next-line camelcase
    static readonly AnalyzeGEP_BLCA: string = 'analyze-gep-blca';
    // eslint-disable-next-line camelcase
    static readonly AnalyzeHLA_IVD: string = 'analyze-hla-ivd';
    // eslint-disable-next-line camelcase
    static readonly AnalyzeHLA_LOH: string = 'analyze-hla-loh';
    static readonly AnalyzeHRDDNA: string = 'analyze-hrd-dna';
    static readonly AnalyzeHRDRNA: string = 'analyze-hrd-rna';
    static readonly AnalyzeIdPathogenCall: string = 'analyze-id-pathogen-call';
    static readonly AnalyzeImmuneProfileScore: string = 'analyze-immune-profile-score';
    static readonly AnalyzeImmunoNSCLC: string = 'analyze-immuno-nsclc';
    static readonly AnalyzeMsi: string = 'analyze-msi';
    static readonly AnalyzeMetastasisColon: string = 'analyze-metastasis-colon';
    static readonly AnalyzePurist: string = 'analyze-purist';
    static readonly AnalyzeRNAExpression: string = 'analyze-rna-expression';
    static readonly AnalyzeTil: string = 'analyze-til';
    static readonly AnalyzeTPM: string = 'analyze-tpm';
    static readonly AnalyzeTumorOrigin: string = 'analyze-tumor-origin';
    static readonly AnalyzeRNAFeatures: string = 'analyze-rna-features';
    static readonly AnalyzeRNAFusion: string = 'analyze-rna-fusion';
    static readonly AnalyzeRNAIsoforms: string = 'analyze-rna-isoforms';
    static readonly AnalyzeSomaticSignatures: string = 'analyze-somatic-signatures';
    static readonly AnalyzeVariantCall: string = 'analyze-variant-call';
    static readonly AnalyzeVariantCharacterization: string = 'analyze-variant-characterization';
    static readonly AnalyzeVariantsFda = 'analyze-variants-fda';
    static readonly AnalyzeVariantsFdaQc = 'analyze-variants-fda-qa';
    static readonly AnalyzeVariantsLdtQc = 'analyze-variants-ldt-qa';
    static readonly CheckFlowcellQuality: string = 'check-flowcell-quality';
    static readonly CreateAccount: string = 'create-account';
    static readonly CollectSample: string = 'collect-sample';
    static readonly DeliverReport: string = 'deliver-report';
    static readonly DeliverSequenceData = 'deliver-sequence-data';
    static readonly DemuxAssetData = 'demux-asset-data';
    static readonly DigitalPathologyScan = 'digital-pathology-scan';
    static readonly DigitalPathologyIHCInterpretation = 'digital-pathology-ihc-interpretation';
    static readonly GenerateRequisitionPdf = 'generate-requisition-pdf';
    static readonly IHCStain: string = 'ihc-stain';
    static readonly ImmunoRepertoire = 'immuno-repertoire';
    static readonly ImmunoResponseRNA = 'immuno-response-rna';
    static readonly InfectiousDiseaseResult = 'infectious-disease-result';
    static readonly MassArray: string = 'mass-array';
    static readonly MatchClinicalTrials: string = 'match-clinical-trials';
    static readonly MatchDepressionTherapies: string = 'match-depression-therapies';
    static readonly MeasureSampleQPCR: string = 'measure-sample-qpcr';
    static readonly PathologyImageQc: string = 'pathology-image-qc';
    static readonly OncoGermline: string = 'onco-germline';
    static readonly ReceiveEcgData: string = 'receive-ecg-data';
    static readonly ReceiveClinicalTrialProgramMatchData: string = 'receive-clinical-trial-program-match-data';
    static readonly ReceiveExternalSequencingData = 'receive-external-sequencing-data';
    static readonly ReceivePatientRecords: string = 'receive-patient-records';
    static readonly ReportMsi: string = 'report-msi';
    static readonly ReportDrdJanssen: string = 'report-drd-janssen';
    static readonly ReportAkesogenCgxGermline: string = 'report-akesogen-cgx-germline';
    static readonly ReportPurist: string = 'report-purist'
    static readonly ReportBRCA: string = 'report-brca'
    static readonly ReportChip: string = 'report-chip';
    static readonly ReportCreateAccount: string = 'report-create-account';
    static readonly ReportCtpmEligibilityCriteria: string = 'report-ctpm-eligibility-criteria';
    static readonly ReportFusion: string = 'report-fusion';
    static readonly ReportGenLabOrder: string = 'report-gen-lab-order';
    static readonly ReportDPYD: string = 'report-dpyd';
    // eslint-disable-next-line camelcase
    static readonly ReportHLA_LOH: string = 'report-hla-loh';
    static readonly ReportHRD: string = 'report-hrd';
    // eslint-disable-next-line camelcase
    static readonly ReportIHC_MMR: string = 'report-ihc-mmr';
    // eslint-disable-next-line camelcase
    static readonly ReportIHC_PDL1_22c3: string = 'report-ihc-pdl1-22c3';
    // eslint-disable-next-line camelcase
    static readonly ReportIHC_PDL1_28_8: string = 'report-ihc-pdl1-28-8';
    // eslint-disable-next-line camelcase
    static readonly ReportIHC_PDL1_SP142: string = 'report-ihc-pdl1-sp142';
    // eslint-disable-next-line camelcase
    static readonly ReportIHC_PDL1_SP263: string = 'report-ihc-pdl1-sp263';
    static readonly ReportImmuneProfileScore: string = 'report-immune-profile-score';
    static readonly ReportImmunoNSCLC: string = 'report-immuno-nsclc';
    static readonly ReportInfectiousDisease: string = 'report-infectious-disease';
    static readonly ReportMetastasisColon: string = 'report-metastasis-colon';
    static readonly ReportNeuroEmergingEvidence = 'report-neuro-emerging-evidence';
    static readonly ReportOncoGermline: string = 'report-onco-germline';
    static readonly ReportQPCRIdPathogen: string = 'report-qpcr-id-pathogen';
    static readonly ReportSequenceDepressionClinical: string = 'report-sequence-depression-clinical';
    static readonly ReportReferenceDepression: string = 'report-reference-depression';
    static readonly ReportRespiratoryPathogenPanel: string = 'report-respiratory-pathogen-panel';
    static readonly ReportSarsCov2: string = 'report-sars-cov-2';
    static readonly ReportSequenceIdPathogen: string = 'report-sequence-id-pathogen';
    static readonly ReportSequenceDNA: string = 'report-sequence-dna';
    static readonly ReportSequenceRNA: string = 'report-sequence-rna';
    static readonly ReportSequenceQNS: string = 'report-sequence-qns';
    static readonly ReportSummary: string = 'report-summary';
    static readonly ReportRecist: string = 'report-recist';
    static readonly ReportOncoNgsCfdnaCdx: string = 'report-onco-ngs-cfdna-cdx';
    static readonly ReportTumorOrigin: string = 'report-tumor-origin';
    static readonly ReportTil: string = 'report-til';
    static readonly RequestTissue: string = 'request-tissue';
    static readonly ReviewPathology: string = 'review-pathology';
    static readonly ReviewPositiveControl: string = 'review-positive-control';
    static readonly RunCohort: string = 'run-cohort';
    static readonly RunImmunoExpressionTargets: string = 'run-immuno-expression-targets';
    static readonly RunImmunoHLA: string = 'run-immuno-hla';
    static readonly RunImmunoInfiltration: string = 'run-immuno-infiltration';
    static readonly RunImmunoMSI: string = 'run-immuno-msi';
    static readonly RunImmunoNeoantigen: string = 'run-immuno-neoantigen';
    static readonly RunImmunoNeoantigenRNA: string = 'run-immuno-neoantigen-rna';
    static readonly RunImmunoViralDetection = 'run-immuno-viral-detection';
    static readonly SelectTherapies: string = 'select-therapies';
    static readonly SequenceIsolate: string = 'sequence-isolate';
    static readonly RunImmunoBtmb: string = 'run-immuno-btmb';
    static readonly AnalyzeFragment: string = 'analyze-fragment';
    static readonly AnalyzeUgt1a1: string = 'analyze-ugt1a1';
    static readonly ReportUgt1a1: string = 'report-ugt1a1';
    static readonly OncoGermlineWithAssay: string = 'onco-germline-with-assay';
    static readonly AnalyzePharmaTrialMatch: string = 'analyze-pharma-trial-match';
    static readonly ReportPharmaTrialMatch: string = 'report-pharma-trial-match';
    static readonly AnalyzeMethylationCall: string = 'analyze-methylation-call';
    static readonly ReportMethylationCall: string = 'report-methylation-call';
    static readonly StopSample: string = 'stop-sample';
    static readonly ReceiveEdgeData: string = 'receive-edge-data';
    static readonly InitiateRefLabOrder: string = 'initiate-ref-lab-order';
    // eslint-disable-next-line camelcase
    static readonly ReportHER2_ISH: string = 'report-her2-ish';
    // eslint-disable-next-line camelcase
    static readonly ReportHER2_IHC: string = 'report-her2-ihc';
    static readonly LotFdaQc: string = 'lot-fda-qa';
    static readonly ReportOncoNGSDNACDx: string = 'report-onco-ngs-dna-cdx';
    static readonly InitiateOrderExtRefLab: string = 'initiate-order-ext-ref-lab';
    static readonly ReceiveSampleExtRefLab: string = 'receive-sample-ext-ref-lab';
    static readonly AnalyzeExtRefLab: string = 'analyze-ext-ref-lab';
    static readonly ReportExtRefLab: string = 'report-ext-ref-lab';
    static readonly ReportDermMerlinLdt: string = 'report-derm-merlin-ldt';
    static readonly AnalyzeCmsCrc: string = 'analyze-cms-crc';
    static readonly ReportAbbvieCmsCrc: string = 'report-abbvie-cms-crc';
    static readonly AnalyzeMRDDNA: string = 'analyze-mrd-dna';
    static readonly ReportMRDDNA: string = 'report-mrd-dna';
    static readonly AnalyzeVariantNegativeBypass: string = 'analyze-variant-negative-bypass';
    static readonly AnalyzeVariantPositiveBypass: string = 'analyze-variant-positive-bypass';
    static readonly RunImmunoIntrepid: string = 'run-immuno-intrepid';
    static readonly EdgeIngress: string = 'edge-ingress';
    static readonly EdgeTranslate: string = 'edge-translate';
    static readonly EdgeEgress: string = 'edge-egress';
    static readonly AnalyzeNGK: string = 'analyze-ngk';
    static readonly RunImmunoHLAv2: string = 'run-immuno-hla-v2';
    static readonly ReportPsychGenotypingDnaPgx: string = 'report-psych-genotyping-dna-pgx';
    static readonly ConsolidateMRDDNA: string = 'consolidate-mrd-dna';

    protected static readonly _valueSet: Set<string> = extractStringValueSet(SupportedItemType);

    static get values(): Set<string> {
        // Always return a new copy.
        return new Set<string>(SupportedItemType._valueSet);
    }
}
